import {PanoramaImages} from "./panoramaImages";

export interface SiteTranslation {
    id;
    siteId;
    language;
    name;
    shortDescription;
    description;
    century;
    listName;
    audioPath;
}


export class SiteDto {
    id;
    image;
    centerImage;
    videoUrl;
    version = 0;
    active = false;
    siteTranslations: SiteTranslation[] = [];
    latitude;
    longitude;
    aerialView;
    free = false;
    notAvailableImage;
    slides = [];
    rotateX;
    rotateY;
    sitePrice;
    panoramaImages:PanoramaImages[] = [];
    totalMonuments;
    seotitle;

    constructor() {
    }
}